import { Reducer } from 'redux';
import { SawmillResponse } from '../.generated/api';

export const UPDATE_SAWMILL_LIST = 'UPDATE_SAWMILL_LIST';

// export interface SawmillUser {
//   email: string;
//   name: string;
//   phone: string;
// }

// export interface Sawmill {
//   id: string;
//   name: string;
//   users: SawmillUser[];
// }

export interface SawmillState {
  sawmills?: SawmillResponse[];
}

export interface UpdateSawmillList {
  type: typeof UPDATE_SAWMILL_LIST;
  sawmills?: SawmillResponse[];
}

type SawmillsActionTypes = UpdateSawmillList;

const sawmillReducer: Reducer<SawmillState, SawmillsActionTypes> = (
  state: SawmillState | undefined,
  incomingAction: SawmillsActionTypes,
): SawmillState => {
  if (state === undefined) {
    return {
      sawmills: [],
    };
  }
  switch (incomingAction.type) {
    case UPDATE_SAWMILL_LIST:
      return {
        ...state,
        sawmills: incomingAction.sawmills?.sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };
    default:
      return state;
  }
};

export { sawmillReducer };
